export default "__VITE_ASSET__BudKCAbH__"